import { Link } from "react-router-dom";
import { Newspaper, ArrowLeft } from "lucide-react";

const BlogPage = () => (
  <main data-testid="blog-page" className="mx-auto flex max-w-3xl flex-col items-center px-4 pb-24 pt-40 text-center sm:px-6">
    <div className="flex h-16 w-16 items-center justify-center rounded-lg bg-brand-tint">
      <Newspaper className="h-8 w-8 text-brand-tinttext" />
    </div>
    <h1 className="mt-8 font-display text-4xl font-bold uppercase tracking-wide text-onsurface">
      The Sellcraft Blog
    </h1>
    <p data-testid="blog-coming-soon" className="mt-4 max-w-md text-sm leading-relaxed text-onsurface2">
      Selling tips, pricing guides and product news are on the way. This section is reserved for our upcoming blog — check back soon.
    </p>
    <Link
      data-testid="blog-back-home-link"
      to="/"
      className="mt-10 inline-flex items-center gap-2 rounded-lg border border-linestrong px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-onsurface transition-colors hover:border-brand-light hover:text-brand-light"
    >
      <ArrowLeft className="h-4 w-4" /> Back to home
    </Link>
  </main>
);

export default BlogPage;
